import React from 'react';
import './ProductPage.css';

const ProductPage: React.FC = () => {
    return (
        <div className="product-page">
            <div className="product-page-bg">
                {/* Main Content */}
                <main className="product-main">
                    <div className="product-banner">
                        <img src="./product/product_page_title.webp" width={"35%"}/>
                    </div>

                    {/* product 1 */}
                    <div className="product-section">
                        <img src="./product/product_1.webp" width={"97%"}/>
                    </div>

                    {/* product 2 */}
                    <div className="product-section">
                        <img src="./product/product_2.webp" width={"94%"}/>
                    </div>

                    {/* product 3 */}
                    <div className="product-section">
                        <img src="./product/product_3.webp" width={"80%"}/>
                    </div>

                    {/* product 4 */}
                    <div className="product-section">
                        <img src="./product/product_4.webp" width={"85%"}/>
                    </div>
                    <div className="product-section">
                        <img src="./product/product_5.webp" width={"100%"}/>
                    </div>
                </main>
            </div>
        </div>
    );
};

export default ProductPage;